import {useTranslation} from 'react-i18next';
import * as css from './ContactRep.css';
import HeadsetIcon from '../../../../../../assets/icons/promotion/HeadsetIcon';

// Display-only for now; rep-contact action (whatsapp/phone) is TBD — no onClick / data-cy yet.
const ContactRep = ({className}: {className?: string}) => {
    const {t} = useTranslation('realtime');
    return (
        <css.pill className={`free-color ${className ?? ''}`.trim()}>
            {t('promotionContactRep')}
            <HeadsetIcon color="currentColor" />
        </css.pill>
    );
};

export default ContactRep;
